/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable quotes */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-use-before-define */
import type {KeyboardEventHandler} from 'react';
import {useEffect, useState} from 'react';
import {Button, Form, InputGroup, Modal} from 'react-bootstrap';
import moment from 'moment-timezone';
import type {
	FieldErrors,
	SubmitHandler,
	UseFormRegister,
} from 'react-hook-form';
import {toast} from 'react-toastify';
import {useForm} from 'react-hook-form';
import CreatableSelect from 'react-select/creatable';

import {usePlanDataAsignationMutation} from 'services';
import type {ResetPeriod, Scope, CurrentDataPlan} from 'interfaces';
const stylePadding = {paddingLeft: '0.5rem'};

type TProps = {
	open: boolean;
	onClose: () => void;
	planSelected: FormData;
	ueId: string;
	isSupiIdentifier: boolean;
	onUpdatePlanData: (plan: CurrentDataPlan) => void;
};

const components = {
	DropdownIndicator: null,
};

interface Option {
	readonly label: string;
	readonly value: string;
}

const createOption = (label: string) => ({
	label,
	value: label,
});

type FormData = {
	name: string;
	activationDate: string;
	expirationDate: string;
	usageThreshold: {
		duration: number;
		totalVolume: number;
		downlinkVolume: number;
		uplinkVolume: number;
		totalVolumeUnit: string;
		downlinkVolumeUnit: string;
		uplinkVolumeUnit: string;
	};

	notBefore: Date;
	notAfter: Date;
	billCycleMonth: number;
	billCycleDay: number;
	billCycleDayOfWeek: number;
	billCycleHour: number;
	billCycleMinute: number;
	groupPlan: boolean;
	groupMembers: string[];
	scopes: Scope[];
	resetPeriod?: ResetPeriod | null;
	time?: string;
	template?: string;
};

let groupPlanPlaceHolder = '';

const ModalPlanAssignation = ({
	open,
	onClose,
	planSelected,
	ueId,
	isSupiIdentifier,
	onUpdatePlanData,
}: TProps) => {
	const [inputValue, setInputValue] = useState('');
	const [valueOptions, setValueOptions] = useState<readonly Option[]>([]);

	const [saveData, {isLoading}] = usePlanDataAsignationMutation();

	groupPlanPlaceHolder = isSupiIdentifier
		? 'SUPI12, SUPI2, SUPI3 ... (click enter or tab key)'
		: 'GPSI1, GPSI2, GPSI3 ... (click enter or tab key)';

	const {
		register,
		handleSubmit,
		formState: {errors},
		setValue,
		watch,
	} = useForm<FormData>();

	const {groupPlan} = watch();

	/* The above code is using the `useEffect` hook in a React component. It is triggered whenever the
	`planSelected` variable changes. */
	useEffect(() => {
		if (planSelected) {
			Object.entries(defaultData(planSelected)).forEach(([name, value]: any) =>
				setValue(name, value),
			);
		}
	}, [setValue, planSelected]);

	const handleAddChange = (newValue: Option[]) => setValueOptions(newValue);
	const handleInputValue = (newValue: string) => setInputValue(newValue);

	/**
	 * The function `handleKeyDown` is a keyboard event handler that adds a new option to a list and
	 * clears the input value when the Enter or Tab key is pressed.
	 * @returns In this code snippet, nothing is being returned. The `handleKeyDown` function is an event
	 * handler for the `keydown` event and does not have a return value.
	 */
	const handleKeyDown: KeyboardEventHandler = e => {
		if (!inputValue) return;
		switch (e.key) {
			case 'Enter':
			case 'Tab':
			case ' ':
				setValueOptions(prev => [...prev, createOption(inputValue)]);
				setInputValue('');
				e.preventDefault();
		}
	};

	const handleClickOutside: KeyboardEventHandler = e => {
		if (!inputValue) return;

		if (e.type === 'blur') {
			setValueOptions(prev => [...prev, createOption(inputValue)]);
			setInputValue('');
			e.preventDefault();
		}
	};

	/**
	 * The `onSubmit` function is an asynchronous function that handles form submission in a TypeScript
	 * React application, saving data and displaying success or error messages.
	 */
	// eslint-disable-next-line @typescript-eslint/require-await
	const onSubmit: SubmitHandler<FormData> = async data => {
		const {time, billCycleMonth, billCycleDay, billCycleDayOfWeek} = data;

		if (!ueId?.trim()) {
			toast.error(
				'Create the subscriber before proceeding with plan assignment.',
			);
			return;
		}

		const times = time && time.split(':');

		delete data.time;
		delete data.resetPeriod;

		try {
			const res = await saveData({
				...data,
				ueId,
				activationDate: data?.activationDate
					? moment
							.tz(data?.activationDate, moment.tz.guess())
							.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
					: null,
				expirationDate: data?.expirationDate
					? moment
							.tz(data?.expirationDate, moment.tz.guess())
							.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
					: null,
				notBefore: data?.notBefore
					? moment
							.tz(data?.notBefore, moment.tz.guess())
							.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
					: null,
				notAfter: data?.notAfter
					? moment
							.tz(data?.notAfter, moment.tz.guess())
							.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
					: null,
				billCycleMonth: Number(billCycleMonth),
				billCycleDay: Number(billCycleDay),
				billCycleDayOfWeek: Number(billCycleDayOfWeek),
				billCycleHour: Number(times ? times[0] : 0),
				billCycleMinute: Number(times ? times[1] : 0),
				groupMembers: valueOptions.length
					? valueOptions.map(el => el.value)
					: [''],
			}).unwrap();

			const currentDTO: CurrentDataPlan = {
				uid: res.uid,
				template: planSelected?.name,
				allowedUsage: res.usedVolumeAndTime,
				usageThreshold: res.usedVolumeAndTime,
				useConsumed: res.usedVolumeAndTime,
				resetTime: res.resetTime,
				resetPeriod: res.resetPeriod,
				notBefore: res.notBefore,
				notAfter: res.notAfter,
				billCycleMonth: res.billCycleMonth,
				billCycleDay: res.billCycleDay,
				billCycleDayOfWeek: res.billCycleDayOfWeek,
				billCycleHour: res.billCycleHour,
				billCycleMinute: res.billCycleMinute,
				groupPlan: res.groupPlan,
				groupMembers: res.groupMembers,
				scopes: res.scopes,
			};
			onUpdatePlanData(currentDTO);

			toast.success('Create Successfully!');
			onClose();
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Modal
			centered
			size="xl"
			show={open}
			onHide={onClose}
			className="custom-modal-style">
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">
					<h4 className="modal-title" id="ModalPlanAssignationLabel">
						Plan Assignation
					</h4>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="show-grid">
				<div className="mb-5">
					<Form
						className="rounded-3 p-2 needs-validation row"
						onSubmit={handleSubmit(onSubmit)}>
						<PlanDetailForm
							register={register}
							errors={errors}
							planSelected={planSelected}
						/>

						<div className="col-xs-12 col-xl-6">
							<ExtraValueForm
								register={register}
								errors={errors}
								periodicity={planSelected?.resetPeriod?.period}
								onAddChange={handleAddChange}
								onInputValue={handleInputValue}
								valueOptions={valueOptions as never}
								inputValue={inputValue}
								onKeyDown={handleKeyDown}
								onClickOutside={handleClickOutside}
								isGroupPlanActive={groupPlan}
							/>

							{/* <ScopesForm
								register={register}
								errors={errors}
								data={{snssai, dnn}}
							/> */}
						</div>

						<div className="col-xs-12 col-xl-3">
							<Button
								disabled={isLoading}
								type="submit"
								className="mt-2"
								variant="primary"
								style={{color: 'white'}}>
								Assign
							</Button>
						</div>
					</Form>
				</div>
			</Modal.Body>
		</Modal>
	);
};

type TPlanDetailForm = {
	register: UseFormRegister<FormData | any>;
	errors: FieldErrors<FormData> | undefined | any;
	planSelected: FormData;
};
const PlanDetailForm = ({register, errors, planSelected}: TPlanDetailForm) => (
	<div className="col-xs-12 col-xl-6">
		<div className="rounded-3 text-bg-light p-2 needs-validation">
			<h2>Plan details</h2>

			<InputGroup className="mb-3">
				<InputGroup.Text style={stylePadding}>Name</InputGroup.Text>
				<Form.Control
					id="name"
					disabled
					defaultValue={planSelected?.name}
					value={planSelected?.name}
					aria-label="name"
					placeholder="Plan-5G-10GB"
					{...register('name', {
						required: 'The field is required',
					})}
					className={errors?.name ? 'is-invalid' : ''}
				/>
				{errors?.name && (
					<small className="invalid-feedback d-block">
						{errors?.name?.message}
					</small>
				)}
			</InputGroup>

			<InputGroup className="mb-3">
				<InputGroup.Text style={stylePadding}>Activation Date</InputGroup.Text>
				<Form.Control
					type="datetime-local"
					// value={activationDate}
					disabled
					id="activationDate"
					aria-label="activationDate"
					{...register('activationDate', {
						required: 'The field is required',
					})}
					className={errors?.activationDate ? 'is-invalid' : ''}
				/>
				{errors?.activationDate && (
					<small className="invalid-feedback d-block">
						{errors?.activationDate?.message}
					</small>
				)}
			</InputGroup>

			<InputGroup className="mb-3">
				<InputGroup.Text style={stylePadding}>Expiration Date</InputGroup.Text>
				<Form.Control
					type="datetime-local"
					disabled
					id="expirationDate"
					aria-label="expirationDate"
					{...register('expirationDate')}
					className={errors?.expirationDate ? 'is-invalid' : ''}
				/>
				{errors?.expirationDate && (
					<small className="invalid-feedback d-block">
						{errors?.expirationDate?.message}
					</small>
				)}
			</InputGroup>

			<div className="border border-secondary rounded p-2 mb-3">
				<label htmlFor="billCycle">Usage Threshold</label>
				{planSelected?.usageThreshold?.duration && (
					<InputGroup className="mb-3">
						<InputGroup.Text style={stylePadding}>Duration</InputGroup.Text>
						<Form.Control
							type="number"
							id="usageThreshold.duration"
							disabled
							aria-label="usageThreshold.duration"
							{...register('usageThreshold.duration')}
							className={errors?.usageThreshold?.duration ? 'is-invalid' : ''}
						/>
						{errors?.usageThreshold?.duration && (
							<small className="invalid-feedback d-block">
								{errors?.usageThreshold?.duration.message}
							</small>
						)}
					</InputGroup>
				)}

				{planSelected?.usageThreshold?.totalVolume && (
					<InputGroup className="mb-3">
						<InputGroup.Text style={stylePadding}>Total Volume</InputGroup.Text>
						<Form.Control
							type="number"
							id="usageThreshold.totalVolume"
							disabled
							aria-label="usageThreshold.totalVolume"
							{...register('usageThreshold.totalVolume')}
							className={
								errors?.usageThreshold?.totalVolume ? 'is-invalid' : ''
							}
						/>
						{errors?.usageThreshold?.totalVolume && (
							<small className="invalid-feedback d-block">
								{errors?.usageThreshold?.totalVolume.message}
							</small>
						)}
						<Form.Select
							aria-label="Gb"
							className="col-xl-3"
							disabled
							{...register('usageThreshold.totalVolumeUnit')}>
							<option disabled value="">
								Units
							</option>
							<option value="b">b</option>
							<option value="Kb">Kb</option>
							<option value="Mb">Mb</option>
							<option value="Gb">Gb</option>
							<option value="Tb">Tb</option>
						</Form.Select>
					</InputGroup>
				)}

				{planSelected?.usageThreshold?.downlinkVolume && (
					<InputGroup className="mb-3">
						<InputGroup.Text style={stylePadding}>
							Downlink Volume
						</InputGroup.Text>
						<Form.Control
							type="number"
							disabled
							id="usageThreshold.downlinkVolume"
							aria-label="usageThreshold.downlinkVolume"
							{...register('usageThreshold.downlinkVolume')}
							className={
								errors?.usageThreshold?.downlinkVolume ? 'is-invalid' : ''
							}
						/>
						{errors?.usageThreshold?.downlinkVolume && (
							<small className="invalid-feedback d-block">
								{errors?.usageThreshold?.downlinkVolume.message}
							</small>
						)}
						<Form.Select
							aria-label="Gb"
							className="col-xl-3"
							disabled
							{...register('usageThreshold.downlinkVolumeUnit')}>
							<option disabled value="">
								Units
							</option>
							<option value="b">b</option>
							<option value="Kb">Kb</option>
							<option value="Mb">Mb</option>
							<option value="Gb">Gb</option>
							<option value="Tb">Tb</option>
						</Form.Select>
					</InputGroup>
				)}

				{planSelected?.usageThreshold?.uplinkVolume && (
					<InputGroup className="mb-3">
						<InputGroup.Text style={stylePadding}>
							Uplink Volume
						</InputGroup.Text>
						<Form.Control
							type="number"
							id="usageThreshold.uplinkVolume"
							disabled
							aria-label="usageThreshold.uplinkVolume"
							{...register('usageThreshold.uplinkVolume')}
							className={
								errors?.usageThreshold?.uplinkVolume ? 'is-invalid' : ''
							}
						/>
						{errors?.usageThreshold?.uplinkVolume && (
							<small className="invalid-feedback d-block">
								{errors?.usageThreshold?.uplinkVolume.message}
							</small>
						)}
						<Form.Select
							aria-label="Gb"
							className="col-xl-3"
							disabled
							{...register('usageThreshold.uplinkVolumeUnit')}>
							<option disabled value="">
								Units
							</option>
							<option value="b">b</option>
							<option value="Kb">Kb</option>
							<option value="Mb">Mb</option>
							<option value="Gb">Gb</option>
							<option value="Tb">Tb</option>
						</Form.Select>
					</InputGroup>
				)}
				{(!planSelected?.usageThreshold ||
					Object.keys(planSelected.usageThreshold).length === 0 ||
					(!planSelected?.usageThreshold.downlinkVolume &&
						!planSelected?.usageThreshold.duration &&
						!planSelected?.usageThreshold.totalVolume &&
						!planSelected?.usageThreshold.uplinkVolume)) && (
					<InputGroup className="mb-3">
						<InputGroup.Text style={stylePadding}>Unlimited</InputGroup.Text>
					</InputGroup>
				)}
			</div>
		</div>
	</div>
);

type TExtraValueForm = {
	register: UseFormRegister<FormData | any>;
	errors: FieldErrors<FormData> | undefined | any;
	periodicity: string | undefined;
	onAddChange: (newValue: Option[]) => void;
	onInputValue: (newValue: string) => void;
	valueOptions: Option[];
	inputValue: string;
	onKeyDown: (e: any) => void;
	onClickOutside: (e: any) => void;
	isGroupPlanActive: boolean;
};
const ExtraValueForm = ({
	register,
	errors,
	periodicity,
	onAddChange,
	onInputValue,
	valueOptions,
	inputValue,
	onKeyDown,
	onClickOutside,
	isGroupPlanActive = false,
}: TExtraValueForm) => (
	<div className="rounded-3 text-bg-light p-2 needs-validation">
		<h2>Plan Instance values</h2>

		<InputGroup className="mb-3">
			<InputGroup.Text style={stylePadding}>Not Before</InputGroup.Text>
			<Form.Control
				type="datetime-local"
				id="notBefore"
				aria-label="notBefore"
				placeholder="2022-09-23T17:32:28Z"
				{...register('notBefore', {
					required: false,
				})}
				className={errors.notBefore ? 'is-invalid' : ''}
			/>
			{errors.notBefore && (
				<small className="invalid-feedback d-block">
					{errors.notBefore.message}
				</small>
			)}
		</InputGroup>

		<InputGroup className="mb-3">
			<InputGroup.Text style={stylePadding}>Not After</InputGroup.Text>
			<Form.Control
				type="datetime-local"
				id="notAfter"
				aria-label="notAfter"
				placeholder="2022-09-23T17:32:28Z"
				{...register('notAfter', {
					required: false,
				})}
				className={errors.notAfter ? 'is-invalid' : ''}
			/>
			{errors.notAfter && (
				<small className="invalid-feedback d-block">
					{errors.notAfter.message}
				</small>
			)}
		</InputGroup>

		{periodicity ? (
			<div className="border border-secondary rounded p-2 mb-3">
				<label htmlFor="billCycle">Bill Cycle</label>
				<Form.Group className="mb-3" controlId="billCycle">
					<Form.Label>Periodicity</Form.Label>
					<Form.Select
						disabled
						aria-label="periodicity"
						value={periodicity ?? ''}>
						<option value="">Select option</option>
						<option value="YEARLY">Yearly</option>
						<option value="MONTHLY">Monthly</option>
						<option value="WEEKLY">Weekly</option>
						<option value="DAILY">Daily</option>
						<option value="HOURLY">Hourly</option>
					</Form.Select>
				</Form.Group>

				<div className="row">
					<div className="col-xs-12 col-md-6">
						<Form.Group className="mb-3" controlId="execution">
							<Form.Label>Month of Year</Form.Label>
							<Form.Select
								disabled={
									periodicity === 'MONTHLY' ||
									periodicity === 'WEEKLY' ||
									periodicity === 'DAILY' ||
									periodicity === 'HOURLY'
								}
								aria-label=": number"
								className={errors?.billCycleMonth ? 'is-invalid' : ''}
								{...register('billCycleMonth', {
									required:
										periodicity === 'YEARLY' ? 'The field is required' : false,
								})}>
								<option>Select</option>
								<option value={1}>January</option>
								<option value={2}>February</option>
								<option value={3}>March</option>
								<option value={4}>April</option>
								<option value={5}>May</option>
								<option value={6}>June</option>
								<option value={7}>July</option>
								<option value={8}>August</option>
								<option value={9}>September</option>
								<option value={10}>October</option>
								<option value={11}>November</option>
								<option value={12}>December</option>
							</Form.Select>
							{errors?.billCycleMonth && (
								<small className="invalid-feedback d-block">
									{errors?.billCycleMonth?.message}
								</small>
							)}
						</Form.Group>
					</div>

					<div className="col-xs-12 col-md-6">
						<Form.Group className="mb-3" controlId="execution">
							<Form.Label>Day of Week</Form.Label>
							<Form.Select
								disabled={
									periodicity === 'YEARLY' ||
									periodicity === 'MONTHLY' ||
									periodicity === 'DAILY' ||
									periodicity === 'HOURLY'
								}
								aria-label="billCycleDayOfWeek"
								className={errors?.billCycleDayOfWeek ? 'is-invalid' : ''}
								{...register('billCycleDayOfWeek', {
									required:
										periodicity === 'WEEKLY' ? 'The field is required' : false,
								})}>
								<option disabled value="" />
								<option value={1}>Monday</option>
								<option value={2}>Tuesday</option>
								<option value={3}>Wednesday</option>
								<option value={4}>Thursday</option>
								<option value={5}>Friday</option>
								<option value={6}>Saturday</option>
								<option value={7}>Sunday</option>
							</Form.Select>
							{errors?.billCycleDayOfWeek && (
								<small className="invalid-feedback d-block">
									{errors?.billCycleDayOfWeek?.message}
								</small>
							)}
						</Form.Group>
					</div>
				</div>

				<div className="row">
					<div className="col-xs-12 col-md-6">
						<Form.Group className="mb-3" controlId="execution">
							<Form.Label>Day of the Month</Form.Label>
							<Form.Select
								disabled={
									periodicity === 'WEEKLY' ||
									periodicity === 'DAILY' ||
									periodicity === 'HOURLY'
								}
								aria-label="billCycleDay"
								className={errors?.billCycleDay ? 'is-invalid' : ''}
								{...register('billCycleDay', {
									required:
										periodicity === 'MONTHLY' || periodicity === 'YEARLY'
											? 'The field is required'
											: false,
								})}>
								<option disabled value="" />
								{Array(31)
									.fill(null)
									.map((_, key) => (
										<option key={key} value={key + 1}>
											{key + 1}
										</option>
									))}
							</Form.Select>
							{errors?.billCycleDay && (
								<small className="invalid-feedback d-block">
									{errors?.billCycleDay?.message}
								</small>
							)}
						</Form.Group>
					</div>

					<div className="col-xs-12 col-md-6">
						<Form.Group className="mb-3" controlId="execution">
							<Form.Label>Time (Server Time)</Form.Label>
							<Form.Control
								type="time"
								aria-label="time"
								className={errors?.time ? 'is-invalid' : ''}
								{...register('time', {
									required: 'The field is required',
								})}
							/>
							{errors?.time && (
								<small className="invalid-feedback d-block">
									{errors?.time?.message}
								</small>
							)}
						</Form.Group>
					</div>
				</div>
			</div>
		) : (
			<div />
		)}

		<Form.Check
			className="mb-3"
			type="checkbox"
			id="default-plan"
			label="Group Plan"
			isInvalid={errors.groupPlan}
			aria-label="groupPlan"
			{...register('groupPlan', {
				required: false,
			})}
		/>

		<CreatableSelect
			isDisabled={!isGroupPlanActive}
			components={components}
			inputValue={inputValue}
			isClearable
			isMulti
			menuIsOpen={false}
			onChange={onAddChange as never}
			onInputChange={onInputValue}
			onKeyDown={onKeyDown}
			onBlur={onClickOutside}
			placeholder={groupPlanPlaceHolder}
			value={valueOptions}
		/>
	</div>
);

/* const ScopesForm = ({register, errors, data}: any) => {
	const [count, setCount] = useState<number[]>([1]);

	const handleAdd = () => {
		if (count.length <= 10) {
			setCount(prevState => [...prevState, 1]);
		}
	};

	const handleRemove = (key: number) => {
		const tmp = [...count];

		if (tmp.length > 1) {
			tmp.splice(key, 1);
			setCount(tmp);
		}
	};

	return (
		<div className="rounded-3 text-bg-light p-2 needs-validation mt-3">
			<div className="d-flex justify-content-between mb-4">
				<h2>Scopes</h2>

				<Button
					type="button"
					variant="secondary"
					style={{color: 'white'}}
					onClick={handleAdd}>
					Add
				</Button>
			</div>

			{count.map((_: number, key: number) => (
				<InputGroup className="mb-3" key={key}>
					<InputGroup.Text style={stylePadding}>SNSSAI</InputGroup.Text>
					<Form.Control
						name="snssai"
						aria-label="snssai"
						placeholder="12345"
						type="number"
						className={errors.snssai ? 'is-invalid' : ''}
						{...register('snssai', {
							required: data.dnn && data.dnn !== '' ? false : true,
						})}
					/>
					<InputGroup.Text style={stylePadding}>DNN</InputGroup.Text>
					<Form.Control
						name="dnn"
						aria-label="dnn"
						placeholder="00:01"
						type="number"
						className={errors.dnn ? 'is-invalid' : ''}
						{...register('dnn', {
							required: data.snssai && data.snssai !== '' ? false : true,
						})}
					/>
					<Button
						variant="outline-secondary"
						style={{color: 'white'}}
						onClick={() => handleRemove(key)}>
						<i
							className="bi-1 bi-trash-fill text-danger"
							title=""
							data-toggle="tooltip"
							data-original-title="Delete"
						/>
					</Button>
				</InputGroup>
			))}
		</div>
	);
}; */

export const defaultData = (state?: FormData | any) => {
	const userTimeZone = moment.tz.guess();
	return {
		name: state?.name || '',
		activationDate: state?.activationDate
			? moment
					.tz(state?.activationDate, userTimeZone)
					.format('YYYY-MM-DDTHH:mm')
			: undefined,
		expirationDate: state?.expirationDate
			? moment
					.tz(state?.expirationDate, userTimeZone)
					.format('YYYY-MM-DDTHH:mm')
			: undefined,
		resetPeriod: state?.resetPeriod ?? null,
		usageThreshold: state?.usageThreshold || null,
		notBefore: state?.notBefore
			? moment.tz(state?.notBefore, userTimeZone).format('YYYY-MM-DDTHH:mm')
			: undefined,
		notAfter: state?.notAfter
			? moment.tz(state?.notAfter, userTimeZone).format('YYYY-MM-DDTHH:mm')
			: undefined,
		billCycleMonth: state?.billCycleMonth || 0,
		billCycleDay: state?.billCycleDay || 0,
		billCycleDayOfWeek: state?.billCycleDayOfWeek || 0,
		billCycleHour: state?.billCycleHour || 0,
		billCycleMinute: state?.billCycleMinute || 0,
		time: state?.time || 0,
		groupPlan: state?.groupPlan || false,
		groupMembers: state?.groupPlan || null,
	};
};

export default ModalPlanAssignation;
